<template>
  <div class="index">
    <!-- 中间图片部分 -->
    <div class="center">
      <div class="table" id="share">
        <CenterTable>
          <!-- 表格标题 -->
          <template v-slot:title>学员打卡日记</template>
          <!-- 表格内容部分 -->
          <template v-slot:content>
            <div class="share_box">
              <div class="share_box_left" v-loading="loding">
                <shareCard
                  v-for="item in list.list"
                  :key="item.share_id"
                  :myitem="item"
                  role="child"
                ></shareCard>
                <!-- <MyPaginnation></MyPaginnation> -->
              </div>
              <div class="share_box_right">
                <topSearch></topSearch>
              </div>
            </div>
          </template>
        </CenterTable>
      </div>
    </div>
    <!-- 底部图片部分 -->
    <div class="footer">
      <!-- 第二个表格 -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CenterTable from "@/components/CenterTable.vue";
import shareCard from "@/components/shareCard.vue";
import topSearch from "@/components/topSearch.vue";
// import MyPaginnation from "@/components/MyPaginnation.vue";
export default {
  name: "index",
  components: {
    CenterTable,
    shareCard,
    topSearch,
    // MyPaginnation,
  },
  data() {
    return {
      list: [],
      loding: true,
      myid: "",
    };
  },
  methods: {
    getShareList() {
      this.$axios
        .get("/getShareList", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            share_id: this.myid,
          },
        })
        .then((doc) => {
          this.list = doc;
          this.loding = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    ...mapState(["token", "agency_id"]),
  },
  created() {
    // 获取路由哈希值用来判断是评论展示页还是评论详情页
    // var id = this.$route.query.id;
    // if (id != null) {
    //   console.log("这个是评论子页面评论编号为" + id);
    //   this.list = 1;
    //   return;
    // }
    // console.log("这个是评论父页面");
    // 请求评论列表
  },
  mounted() {
    this.myid = this.$route.params.id;
    this.getShareList();
  },
};
</script>

<style lang="less" scoped>
//   内容中间部分
.center {
  position: relative;
  width: 100%;
  height: auto;
  // background: url(../../assets/indexImage/center.png) no-repeat;
  // background-size: 100% 100%;
  // overflow-y:hidden;
  // 中间表格部分
  .table {
    z-index: 9;
    position: relative;
    top: 0;
    left: 0;
  }
  .leftOne_bg {
    position: absolute;
    left: 0;
    top: 15%;
    z-index: 0;
    width: 15rem;
    height: 49.5rem;
  }
  .rightOne_bg {
    position: absolute;
    right: 6.1875rem;
    top: 40%;
    z-index: 0;
    width: 10.5625rem;
    height: 23.4375rem;
  }
  //   打卡分享盒子
  .share_box {
    box-sizing: border-box;
    padding: 0 7.0625rem 6.9375rem;
    display: flex;
    flex-direction: row;
    .share_box_left {
      width: 43.125rem;
      background: #ffffff;
      /deep/ .sharEditItem:last-child{
        display: none;
      }
      /deep/ .sharCard:first-child {
        margin-top: 0;
      }
      // // 上下页部分
      // .pagination {
      //   display: flex;
      //   flex-direction: row;
      //   justify-content: center;
      //   align-items: center;
      //   margin-top: 0.75rem;
      //   height: 2.1875rem;
      //   width: 100%;
      //   background: #ffffff;
      //   border: 1px solid #eeeeee;
      //   cursor: pointer;
      // }
      // .previ,
      // .next {
      //   font-size: 12px;
      //   font-family: "Microsoft YaHei";
      //   font-weight: 400;
      //   color: #555555;
      // }
      // .pagination_heng {
      //   margin: 0 2.4375rem;
      //   width: 0.0625rem;
      //   height: 1.125rem;
      //   background: #d9d9d9;
      // }
    }
    .share_box_right {
      margin-left: 0.6875rem;
      width: 18.75rem;
    }
  }
  /deep/ .heng_table {
    background-color: #f7f7f7;
  }
}
// 内容最下部分
.footer {
  padding-bottom: 6.25rem;
  width: 100%;
}

/deep/ .heng {
  top: 0 !important;
}

/deep/ .heng_table {
  top: -3.6rem !important;
}
/deep/ .table{
  left: -2.8125rem !important;
} 
</style>